export const DESIGNER_TYPE_OPTIONS = [{ value: 'User' }, { value: 'UGC' }]

export const DESIGNER_STATUS_OPTIONS = [
  { value: 1, label: '下线' },
  { value: 2, label: '上线' },
  { value: 3, label: '用户注册' },
]

export const DESIGNER_AUTH_OPTIONS = [
  { value: 0, label: '未认证' },
  { value: 1, label: '已认证' },
]

export const WALLPAPER_TYPE_OPTIONS = [
  '静态壁纸资源',
  '视频壁纸资源',
  '4D Parallax壁纸资源',
  '重力壁纸资源',
]

const WALLPAPER_STATUS = {
  0: { label: '下线', pill: 'offline' },
  1: { label: '上线', pill: 'online' },
  2: { label: '用户取消', pill: 'pending' },
  3: { label: '用户删除', pill: 'failed' },
  10: { label: '资源处理中', pill: 'pending' },
  11: { label: '资源处理失败', pill: 'failed' },
}

export const WALLPAPER_STATUS_OPTIONS = Object.keys(WALLPAPER_STATUS).map((value) => ({
  value,
  label: WALLPAPER_STATUS[value].label,
}))

export function designerStatusLabel(status) {
  if (status === 2) return '上线'
  if (status === 3) return '用户注册'
  return '下线'
}

export function designerStatusPill(status) {
  if (status === 2) return 'online'
  if (status === 3) return 'pending'
  return 'offline'
}

export function wallpaperStatusView(status) {
  return WALLPAPER_STATUS[status] || { label: '未知', pill: 'offline' }
}

export function categoryTagTone(id) {
  const numeric = Number(id)
  if (!Number.isFinite(numeric)) return 0
  return Math.abs(numeric) % 6
}

export function isFilterFilled(value) {
  return value !== '' && value !== null && value !== undefined
}
